export default "__VITE_ASSET__CDb0fyjy__"